import { render, staticRenderFns } from "./ScoutFormFreeWord.vue?vue&type=template&id=67f20493"
import script from "./ScoutFormFreeWord.vue?vue&type=script&lang=js"
export * from "./ScoutFormFreeWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports